"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processOtdrBreakpoint = void 0;
const camelcase_keys_1 = __importDefault(require("camelcase-keys"));
const standardizeFeature_1 = require("./standardizeFeature");
function processOtdrBreakpoint(resp) {
    // Note: renaming break to breakAt because break is reserved keyword
    const _a = resp.data.result, { break: breakAt, cables, terminal_feature: terminalFeature } = _a, others = __rest(_a, ["break", "cables", "terminal_feature"]);
    resp.data.result = Object.assign({ breakAt: (0, camelcase_keys_1.default)(breakAt), cables: cables.map((c) => (0, standardizeFeature_1.standardizeFeature)(c)), terminalFeature: (0, standardizeFeature_1.standardizeFeature)(terminalFeature) }, (0, camelcase_keys_1.default)(others, { deep: true }));
}
exports.processOtdrBreakpoint = processOtdrBreakpoint;
//# sourceMappingURL=otdrBreakpoint.js.map